// extracted by mini-css-extract-plugin
module.exports = {"signupContainer":"Signup_signupContainer__2CQ-w","signupTitle":"Signup_signupTitle__1LHEB"};